import { createFileRoute } from "@tanstack/react-router";
import { SEOPage } from "@/components/site/SEOPage";

export const Route = createFileRoute("/tutoriais-iptv/")({
  head: () => ({
    meta: [
      { title: "Tutoriais IPTV - Central de Ajuda Completa | P2 PRO" },
      { name: "description", content: "Aprenda a instalar e configurar IPTV em qualquer dispositivo. Tutoriais passo a passo para Samsung, LG, Fire Stick, Android, iPhone e muito mais." },
      { name: "keywords", content: "tutoriais iptv, como instalar iptv, central de ajuda iptv, guia instalacao iptv" },
    ],
  }),
  component: () => (
    <SEOPage
      variant="centered"
      category="Central de Ajuda"
      title="TUTORIAIS IPTV: APRENDA A INSTALAR DO ZERO"
      subtitle="Guia prático e rápido para você configurar seu entretenimento em qualquer tela, sem complicações."
      introParagraphs={[
        "Nossa central de tutoriais foi desenvolvida para garantir que você tenha a melhor experiência possível com o servidor P2 PRO, independentemente do dispositivo que utiliza. Sabemos que cada sistema operacional (Tizen, WebOS, Android, iOS) tem suas particularidades, e por isso criamos guias específicos para cada um.",
        "Aqui você encontrará o passo a passo detalhado para instalar os aplicativos mais estáveis do mercado, configurar sua lista de canais e otimizar a qualidade da imagem para 4K nativo. Navegue pelas categorias abaixo e transforme seu dispositivo em uma central de entretenimento premium."
      ]}
      benefits={[
        { title: "Tutoriais em Vídeo", description: "Acesso a guias visuais para facilitar ainda mais sua configuração." },
        { title: "Suporte 24h", description: "Dúvidas técnicas? Nosso time está online para te ajudar no WhatsApp." },
        { title: "Atualizações", description: "Guias revisados mensalmente para acompanhar as mudanças dos sistemas." }
      ]}
      howItWorks={[
        { title: "Dispositivo", description: "Escolha o aparelho onde deseja instalar o serviço (TV, Celular, Box)." },
        { title: "Aplicativo", description: "Siga o guia para baixar o app recomendado para seu sistema." },
        { title: "Configuração", description: "Insira os dados da sua lista P2 PRO conforme as instruções." },
        { title: "Diversão", description: "Pronto! Acesse sua grade completa de canais, filmes e séries." }
      ]}
      diferenciais={[
        { title: "Linguagem Simples", description: "Explicamos termos técnicos de forma que qualquer pessoa entenda." },
        { title: "Apps Oficiais", description: "Focamos em aplicativos seguros e presentes nas lojas oficiais." },
        { title: "Foco em 4K", description: "Configurações específicas para garantir a máxima qualidade de imagem." }
      ]}
      faq={[
        { question: "Preciso pagar pelos aplicativos?", answer: "Alguns apps são gratuitos e outros possuem versões Pro pagas. Recomendamos sempre as melhores opções custo-benefício." },
        { question: "O tutorial serve para qualquer servidor?", answer: "Sim, os passos de instalação são universais, mas o desempenho depende da qualidade do servidor que você usa." },
        { question: "Não consegui instalar, e agora?", answer: "Basta clicar no botão de WhatsApp e falar com nosso suporte técnico agora mesmo." }
      ]}
      breadcrumbs={[{ label: "Tutoriais", href: "/tutoriais-iptv" }]}
      relatedArticles={[
        { title: "IPTV na TV Samsung", href: "/tutoriais-iptv/samsung" },
        { title: "IPTV na TV LG", href: "/tutoriais-iptv/lg" },
        { title: "IPTV no Fire Stick", href: "/tutoriais-iptv/fire-stick" }
      ]}
    />
  ),
});
